/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 14:18:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-15 16:36:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/FlashSale/FlashSaleList/slice/index.tsx
 */
import { createSlice } from '@reduxjs/toolkit';
import { unique } from '@/src/tools/helper';
import { tabsConfig } from '../config';

const defaultState = {
  tabsActive: tabsConfig({ getI18n: null })[0].key,
  searchList: [],
  searchText: 0,
  filter: {},
  sort: {
    name: 'Created ( newest )',
    key: 8,
    data: { field: 'createdDate', ascent: false },
  },
  tableSettings: [],
  allDataTotal: 0,
};
//TODO:Filter单选和多选的问题
const flashSaleListSlice = createSlice({
  name: 'salesChannelDiscountsFlashSale',
  initialState: defaultState,
  reducers: {
    searchList: (state, action) => {
      state.searchList.push(action.payload);
      state.searchList = unique(state.searchList); //去重
    },
    deleteSearch: (state, action) => {
      state.searchList.splice(action.payload, 1);
    },
    onFilter: (state, action) => {
      state.filter = action.payload;
    },
    eachOnFilter: (state, action) => {
      state.filter[action.payload.key] = action.payload.data;
    },
    filterClose: (state, action) => {
      state.filter[action.payload.key].splice(action.payload.index, 1);
    },
    sortBy: (state, action) => {
      state.sort = action.payload;
    },
    activeChange: (state, action) => {
      state.tabsActive = action.payload;
    },
    setTableSetting: (state, action) => {
      state.tableSettings = action.payload;
    },
    removeFilter: (state) => {
      state.searchList = [];
      state.filter = {};
    },
    setAllDataTotal: (state, action) => {
      state.allDataTotal = action.payload;
    },
  },
});

export const {
  searchList,
  deleteSearch,
  onFilter,
  eachOnFilter,
  sortBy,
  activeChange,
  setAllDataTotal,
  filterClose,
  removeFilter,
  setTableSetting,
} = flashSaleListSlice.actions;

export default flashSaleListSlice.reducer;
